import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-card-simple-text',
  styleUrl: 'card-simple-text.css',
  shadow: true,
})
export class CardSimpleText {
  @Prop() backgroundColor: string;

  render() {
    return (
      <Host style={{
        backgroundColor: this.backgroundColor
      }}>
        <slot></slot>
      </Host>
    );
  }

}
